import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { HttpService } from "../../services/http/http.service";
import { MatCardModule } from "@angular/material/card";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDatepickerModule } from "@angular/material/datepicker";

@Component({
  selector: 'add-code-dialog',
  templateUrl: './add-code-dialog.component.html',
  styleUrls: ['./add-code-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, MatInputModule, FormsModule, MatCardModule, MatTooltipModule, MatDatepickerModule],
})
export class AddCodeDialog {

  checkOverrideProposta: boolean = false;
  duplicatedRecord: any = {};
  newProfile: any;
  constructor(
    public dialogRef: MatDialogRef<AddCodeDialog>,
    private snackBar: MatSnackBar,
    private api: HttpService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.newProfile = this.data.newProfile;
  }

  handleAssignment() {
    this.api.assegnaCodiceProfilo({ codiceProfilo: this.data.code, idProposta: this.data.idProposta }).subscribe({
      next: (response: any) => {
        if (response.result.valore) {
          this.handleDialogClose()
          this.snackBar.open('Codice aggiunto con successo', 'close', { panelClass: 'successSnack' });
        } else {
          this.checkOverrideProposta = true;
          this.checkDuplicate()
          this.snackBar.open('Trovato profilo esistente con codice profilo uguale a quello inserito.', 'close', { panelClass: 'errorSnack' });
        }
      },
      error: (err: any) => {
        console.error('Errore durante il salvataggio del codice:', err);
        this.snackBar.open('Errore durante il salvataggio del codice', 'close', { panelClass: 'errorSnack' });
      }
    });
  }

  checkDuplicate() {
    this.api.ricercaCodiceProfilo(this.data.code, this.data.idProposta)
      .subscribe({
        next: (response: any) => {
          this.duplicatedRecord = response;
          if (!this.newProfile.descrizioneProfilo) {
            this.newProfile.descrizioneProfilo = this.duplicatedRecord.profilo.descrizioneProfilo;
          }
          this.newProfile.codiceProfilo = this.data.code;
        },
        error: (err: any) => {
          this.snackBar.open("Errore durante il recupero della proposta. ", 'close', { panelClass: 'errorSnack' });
        }
      })
  }

  switchOverReplaceAndArchiveMode() {
    this.checkOverrideProposta = !this.checkOverrideProposta;
  }

  replaceAndArchive() {
    
    const copiedRecord = JSON.parse(JSON.stringify(this.duplicatedRecord));
  
    copiedRecord.profilo=this.newProfile;
   
    this.api.archiviaProfiloEProposta(copiedRecord, this.data.idProposta)
      .subscribe({
        next: (response: any) => {
          this.handleDialogClose();
        },
        error: (error: any) => {
          console.error(error);
        }
      });
  }


  onClose(): void {
    this.dialogRef.close();
  }

  handleDialogClose() {
    this.data.confirm = true;
    this.dialogRef.close(this.data);
  }
}
